import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { setupAxiosInterceptor } from './utils/axiosInterceptor';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Configurar interceptor de axios para refresh automático de tokens
setupAxiosInterceptor();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker for PWA functionality
// This enables offline capabilities and faster loading
serviceWorkerRegistration.register();
